export const text = {
  Save: "Opslaan",
  Yes: "Ja",
  No: "Nee",
  Cancel: "Annuleren",
  Add: "Toevoegen",
  Actions: "Acties",
  Enddatemustbegreaterthanstartdate:
    "Einddatum moet later zijn dan de startdatum",
  Pleasefilloutallrequiredfields: "Vul alle verplichte velden in",
  Areyousureyouwanttodeletethis: "Weet u zeker dat u dit wilt verwijderen?",
  Id: "Id",
  Title: "Titel",
  Status: "Status",
  Submit: "Opslaan",
  addedsuccessfully: "succesvol toegevoegd",
  updatedsuccessfully: "succesvol bijgewerkt",
  deletedsuccessfully: "succesvol verwijderd",
  cancelledsuccessfully: "succesvol geannuleerd",
  submittedsuccessfully: "succesvol ingediend",
  Draft: "Concept",
  Submitted: "Ingediend",
  Cancelled: "Geannuleerd",
  Delete: "Verwijderen",
  Update: "Bijwerken",
  Areyousureyouwanttocancelthis: "Weet u zeker dat u dit wilt annuleren",
  Areyousureyouwanttosubmitthis: "Weet u zeker dat u dit wilt indienen",
  CreatedAt: "Aangemaakt op",
  Owner: "Eigenaar",
  Areyousureyouwanttologout: "Weet u zeker dat u wilt uitloggen?",
  NoDataFound: "Geen gegevens gevonden",
  SubmittedBy: "Ingediend door",
  SubmittedOn: "Ingediend op",
  Completed: "Afgerond",
  Pending: "Wachtende",
  Overdue: "Verlopen",
  Submitted: "Ingediend",
  Rejected: "Afgewezen",
  Approved: "Goedgekeurd",
  Poll: "Peiling",
  Subjective: "Subjectief",
  Objective: "Doelstelling",
  Documentation: "Documentatie",
  Video: "Video",
  Quiz: "Quiz",
  Image: "Afbeelding",
  Monday: "Maandag",
  Tuesday: "Dinsdag",
  Wednesday: "Woensdag",
  Thursday: "Donderdag",
  Friday: "Vrijdag",
  Saturday: "Zaterdag",
  Sunday: "Zondag",
  Male: "Man",
  Female: "Vrouw",
  Other: "Anders",
  "Onboarding Task": "Onboardingtaak",
  in_progress: "Overzicht",
  completed: "Afgerond",
  Somethingwentwrong: "Er is iets misgegaan",
  DataNotFound: "Geen gegevens gevonden",
  Time: "tijd",
  DateTime: "Datum tijd",
  TextInput: "Klein tekstvak",
  TextArea: "Groot tekstvak",
  multiplechoice: "Meerkeuze",
  Dropdown: "Keuzemenu",
  Checkboxes: "Selectievakjes",
  Rating: "Beoordeling",
  FileUpload: "Bestand uploaden",
  On: "Aan",
  Off: "Uit",

  "place-holder-option-1": "Optie 1",
  "place-holder-option-2": "Optie 2",
  "place-holder-option-3": "Optie 3",
  SeeMore: "Meer weergeven",
  notifications: "Meldingen",
  NoNotifications: "Geen Meldingen",
};
